/**
 * WebAssembly加载工具
 * 用于优化WebAssembly文件的加载和缓存
 */

// 缓存对象，记录已预加载的文件
const wasmCache = new Set();

/**
 * 创建自定义的locateFile函数
 * 这个函数被mxcad库使用，用于定位WASM文件
 * @param {string} basePath - 基础路径
 * @returns {function} locateFile函数
 */
export function createLocateFile(basePath = "/") {
  return function (filename) {
    // 确保路径格式正确
    const path = basePath.endsWith("/") ? basePath : basePath + "/";
    return `${path}${filename}`;
  };
}

/**
 * 预加载WebAssembly模块
 * @param {Array<string>} paths - 要预加载的WASM文件路径
 */
export function preloadWasmModules(paths) {
  if (!Array.isArray(paths)) {
    paths = [paths];
  }

  paths.forEach((path) => {
    // 避免重复预加载
    if (wasmCache.has(path)) {
      return;
    }

    wasmCache.add(path);

    // 使用link标签预加载
    const link = document.createElement("link");
    link.rel = "preload";
    link.href = path;
    link.as = "fetch";
    link.crossOrigin = "anonymous";
    link.type = "application/wasm";
    document.head.appendChild(link);

    // 添加浏览器对WebAssembly的MIME类型支持配置
    if (typeof WebAssembly.instantiateStreaming === "function") {
      const originalInstantiateStreaming = WebAssembly.instantiateStreaming;
      WebAssembly.instantiateStreaming = (response, importObject) => {
        const contentType = response.headers.get("Content-Type") || "";

        // 如果响应头不包含正确的MIME类型，降级为非流式加载
        if (!contentType.includes("application/wasm")) {
          return response
            .arrayBuffer()
            .then((buffer) => WebAssembly.instantiate(buffer, importObject));
        }

        return originalInstantiateStreaming(response, importObject);
      };
    }
  });
}

export default {
  createLocateFile,
  preloadWasmModules,
};
